// import React, { useEffect, useState } from 'react';
// import Cookies from "js-cookie";
// import { config } from '../CommonUrl/CommonUrls';
// import { InfoAlert } from '../CommonPopupAndAlerts/SweetAlerts';

// const SecureImage = ({ filePath }) => {
//     let token = Cookies.get("jwtToken");
//     const [imageUrl, setImageUrl] = useState(null);

//     useEffect(() => {
//         const fetchImage = async () => {

//             if (!filePath) return;
//             try {
//                 const response = await fetch(`${config.url.BOC_URL}file-download?filePath=${encodeURIComponent(filePath)}`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`
//                     }
//                 });

//                 if (!response.ok) throw new Error('Failed to fetch image');
//                 console.log('response', response);
//                 fetch(response.url, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 })
//                     .then((res) => res.blob())
//                     .then((blob) => {
//                         const reader = new FileReader();
//                         reader.onload = () => {
//                             // This will be a Base64 string (e.g., "data:image/png;base64,...")
//                             setImageUrl(reader.result);
//                         };
//                         reader.readAsDataURL(blob); // Convert Blob to Base64
//                     })
//                     .catch((error) => {
//                         console.error("Error loading image:", error);
//                     });
//             } catch (error) {
//                 console.error('Error loading image:', error);
//             }
//         };

//         fetchImage();
//     }, [filePath, token]);

//     // useEffect(() => {
//     //     const blockAccess = (e) => {
//     //         // Block keyboard shortcuts
//     //         if (e.key === 'F12' ||
//     //             (e.ctrlKey && e.shiftKey && e.key === 'I') || // Chrome, Edge, Firefox
//     //             (e.ctrlKey && e.shiftKey && e.key === 'J') || // Chrome console
//     //             (e.ctrlKey && e.shiftKey && e.key === 'C') || // Chrome inspector
//     //             (e.ctrlKey && e.key === 'U') || // View source
//     //             (e.metaKey && e.altKey && e.key === 'I') || // Safari
//     //             (e.key === 'ContextMenu')) { // Right click menu key
//     //             e.preventDefault();
//     //             InfoAlert('Developer tools are disabled for security reasons.');
//     //             return;
//     //         }

//     //         // Block right-click context menu
//     //         if (e.button === 2) {
//     //             e.preventDefault();
//     //             InfoAlert('Context menu is disabled for security reasons.');
//     //             return;
//     //         }
//     //     };

//     //     // Block touch gestures (this will affect UX)
//     //     const blockTouch = (e) => {
//     //         if (e.touches.length > 1) { // Multi-touch gestures
//     //             e.preventDefault();
//     //             InfoAlert('Gestures are disabled for security reasons.');
//     //         }
//     //     };

//     //     // Additional protection against devtools opening
//     //     const blockDevToolsOpen = () => {
//     //         if (window.outerWidth - window.innerWidth > 100 ||
//     //             window.outerHeight - window.innerHeight > 100) {
//     //             // This detects if devtools might be open (window size difference)
//     //             // window.location.reload();
//     //             window.location.href = '/login';
//     //             InfoAlert('Developer tools are disabled for security reasons.');
//     //         }
//     //     };

//     //     // Set up all the event listeners
//     //     window.addEventListener('keydown', blockAccess);
//     //     window.addEventListener('contextmenu', blockAccess);
//     //     window.addEventListener('touchstart', blockTouch, { passive: false });
//     //     window.addEventListener('touchmove', blockTouch, { passive: false });

//     //     // Check periodically for devtools
//     //     const checkInterval = setInterval(blockDevToolsOpen, 1000);

//     //     return () => {
//     //         window.removeEventListener('keydown', blockAccess);
//     //         window.removeEventListener('contextmenu', blockAccess);
//     //         window.removeEventListener('touchstart', blockTouch);
//     //         window.removeEventListener('touchmove', blockTouch);
//     //         clearInterval(checkInterval);
//     //     };
//     // }, []);
//     // const [devToolsOpen, setDevToolsOpen] = useState(false);

//     // useEffect(() => {
//     //     const threshold = 160;
//     //     let checkDevTools = setInterval(() => {
//     //         const widthThreshold = window.outerWidth - window.innerWidth > threshold;
//     //         const heightThreshold = window.outerHeight - window.innerHeight > threshold;
//     //         const isOpen = widthThreshold || heightThreshold;

//     //         if (isOpen !== devToolsOpen) {
//     //             setDevToolsOpen(isOpen);
//     //         }
//     //     }, 1000);

//     //     return () => clearInterval(checkDevTools);
//     // }, [devToolsOpen]);
//     return imageUrl ? (
//         <>


//             <div
//                 style={{
//                     display: 'inline-block',
//                     position: 'relative',
//                     userSelect: 'none',
//                     pointerEvents: 'none' // Blocks all mouse interactions
//                 }}
//             >
//                 <img
//                     src={imageUrl}
//                     alt="Secure Preview"
//                     style={{
//                         maxWidth: '100px',
//                         maxHeight: '100px',
//                         opacity: 0.99, // Fix for Firefox pointerEvents bug
//                     }}
//                     onContextMenu={(e) => e.preventDefault()}
//                     onDragStart={(e) => e.preventDefault()}
//                 />
//             </div>

//         </>

//     ) : (
//         <span>No image</span>
//     );
// };

// export default SecureImage;


import React, { useEffect, useState } from 'react';
import Cookies from "js-cookie";
import Swal from 'sweetalert2'; 
import { config } from '../CommonUrl/CommonUrls';
import { InfoAlert } from '../CommonPopupAndAlerts/SweetAlerts';

const SecureImage = ({ filePath }) => {
    const token = Cookies.get("jwtToken");
    const [imageUrl, setImageUrl] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            if (!filePath) return;

            try {
                const response = await fetch(`${config.url.BOC_URL}file-download?filePath=${encodeURIComponent(filePath)}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!response.ok) throw new Error('Failed to fetch image');

                fetch(response.url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((res) => res.blob())
                .then((blob) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        setImageUrl(reader.result); // Base64 string
                    };
                    reader.readAsDataURL(blob);
                })
                .catch((error) => {
                    console.error("Error loading image:", error);
                });
            } catch (error) {
                console.error('Error loading image:', error);
            }
        };

        fetchImage();
    }, [filePath, token]);
     console.log('filePath:', filePath, typeof filePath);

    const handleImageClick = () => {
        if (!imageUrl) return;
        Swal.fire({
            html: `<img src="${imageUrl}" class="img-thumbnail" style="max-width: 100%; height: auto;" />`,
            width: "80%",
            showCloseButton: true,
            showConfirmButton: false,
            customClass: {
                content: "custom-modal-content",
            },
        }).then(() => {
            // Optional: callback after modal close
        });

        // Handle back button closing
        const handlePopState = () => {
            Swal.close();
        };

        window.addEventListener("popstate", handlePopState);

        // Cleanup when modal is closed
        Swal.getPopup()?.addEventListener('close', () => {
            window.removeEventListener("popstate", handlePopState);
        });
    };

    return imageUrl ? (
        <div
            style={{
                display: 'inline-block',
                position: 'relative',
                userSelect: 'none',
            }}
        >
            <img
                src={imageUrl}
                alt="Secure Preview"
                style={{
                    maxWidth: '100px',
                    maxHeight: '100px',
                    opacity: 0.99,
                    cursor: 'pointer',
                }}
                onClick={handleImageClick}
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
            />
        </div>
    ) : (
        <span>No image</span>
    );
};

export default SecureImage;
